<template>

    <div id="app">
        <QuestionDialog v-model="isOverlayVisible" @genTestSuccess="listenUpdateSuccess" :vid="VisitorObj?.visitorid || null"></QuestionDialog>
        <!--编辑信息  top="6px" -->
        <el-dialog title="编辑来访者信息" :visible.sync="showEditInfo" width="600px" @close="addVisitorClose">
            <div class="">
                <el-form ref="formRef" :model="form_addvisitor" :rules="rules">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="visitorName" style="margin-bottom: 5px;">
                                <div class="pr-2">
                                    <el-input v-model="form_addvisitor.visitorName" placeholder="请输入姓名" />
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="年龄" prop="age" style="margin-bottom: 5px;">
                                <el-input v-model="form_addvisitor.age" placeholder="请输入年龄" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>

                        <el-col :span="8">
                            <el-form-item label="生理性别" prop="gender" style="margin-bottom: 5px;">
                                <el-radio-group v-model="form_addvisitor.gender" left="1px">
                                    <el-radio label="男">男</el-radio>
                                    <el-radio label="女">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>

                        <el-col :span="16" style="margin-right:2px">
                            <el-form-item label="首次访问时间" prop="visitDate" style="margin-bottom: 5px;">
                                <div>
                                    <el-date-picker v-model="form_addvisitor.visitDate"
                                                    type="datetime"
                                                    clearable
                                                    placeholder="选择日期时间" />
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="联系方式" style="margin-bottom: 5px;">
                        <el-input v-model="form_addvisitor.contact" placeholder="请输入联系方式" />
                    </el-form-item>
                    <el-form-item label="主要症状" style="margin-bottom: 5px;">
                        <el-input v-model="form_addvisitor.symptoms" placeholder="请输入主要症状" />
                    </el-form-item>
                    <el-form-item label="来访背景关键信息" style="margin-bottom: 5px;">
                        <el-input type="textarea" :rows="4" v-model="form_addvisitor.backgroundInfo" placeholder="请输入来访背景关键信息" />
                    </el-form-item>

                    <div class="flex justify-end">
                        <el-button type="text" @click="closeDialog">取消</el-button>
                        <el-button type="primary" @click="submitAddVisitorForm">保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!-- viewConfirm -->
        <el-dialog top="50px" :visible.sync="isShowSoundRecording" width="660px" @close="soundRecordClose">
            <div v-if="!isSmallScreen" class="bg-white shadow-lg rounded-lg  sm:p-10">
                <div class="flex items-center justify-center">
                    <h4 class="text-xl font-semibold">录音知情同意书</h4>
                </div>
                <div v-if="confirmObj.confirmSta">
                    <div class="w-[520px] mx-auto">
                        <div v-if="!confirmObj.visitorSign">
                            <span class="font-bold text-2xl">咨询师确认：来访者已签署其他同等效力形式的协议</span>
                        </div>
                        <img v-else :src="confirmObj.visitorSign" alt="Agreement Image" class="w-[100%]">
                    </div>
                </div>
                <div v-else id="agreecontent" class="flex flex-col rounded-3xl border border-gray-300 p-6 mt-8">
                    <div class="mb-4 text-left">
                        <div>来访者同意心理咨询师对咨询全程进行录音，录音文件用于案例督导分析、学习及讨论。</div>
                        <div>在使用过程中，心理咨询师不得泄露可识别来访者的个人信息包括:姓名、住址、电话、工作单位、体貌特征等。咨询师有责任妥善保管录音文件，在案例结案之后及时删除。若需书面出版引用录音文件相关内容，则需另外征得来访者的同意，并另行签署知情同意书。</div>
                    </div>
                    <div class="flex flex-col justify-between">
                        <div class="flex justify-between items-start">
                            <div class="flex flex-col mt-1 p-1">
                                <div class="flex items-center">
                                    <span>来访者：</span>
                                    <span id="visitorName" class="ml-2">待来访者填写</span>
                                </div>
                                <div class="flex items-center mt-2">
                                    <span>日期：</span>
                                    <span id="visitorDate" class="ml-2">待填写后生成</span>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex items-center">
                                    <span>咨询师：</span>
                                    <input placeholder="待填写"
                                           @blur="checkCNickName"
                                           v-model="consultantNickNmae"
                                           type="text"
                                           id="input-13"
                                           class="border border-gray-400 rounded-md p-2 ml-2 " />
                                </div>
                                <div class="flex items-center">
                                    <span>日期：</span>
                                    <span class="ml-2">{{currentDate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-alert v-if="showConsultantAlert"
                              type="warning"
                              description="请输入咨询师名称"
                              show-icon
                              :center="true"></el-alert>
                </div>
                <div class="flex flex-col items-center gap-4 mt-4">
                    <button v-if="confirmObj.confirmSta" type="button"
                            class="bg-green-200 text-black py-2 px-4 rounded-lg shadow-md flex items-center"
                            style="color: rgb(0, 0, 0);">
                        <i class="fas fa-check text-green-600 mr-2" aria-hidden="true"></i>
                        <span class="text-green-600">来访者已确认</span>
                    </button>
                    <button v-else type="button"
                            @click="!showConsultantAlert ? showConfirmEmail = true : showConfirmEmail = false"
                            class="bg-blue-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700">
                        发送给来访者确认
                    </button>
                    <button type="button"
                            :disabled="confirmObj.confirmSta !== false"
                            @click="showFurtherConfirm=true"
                            class="text-blue-400 hover:bg-sky-100 p-2 rounded-lg">
                        来访者已和我签署了其他同等效力形式的协议，无需二次签署
                    </button>
                </div>
            </div>
            <div v-else class="bg-white shadow-lg rounded-lg p-4 sm:p-6">
                <!-- 标题 -->
                <div v-if="confirmObj.confirmSta" class="flex flex-col items-center">
                    <div class="w-auto h-auto">
                        <div v-if="!confirmObj.visitorSign">
                            <span class="font-bold text-2xl">咨询师确认：来访者已签署其他同等效力形式的协议</span>
                        </div>
                        <img v-else :src="confirmObj.visitorSign" alt="Agreement Image" class="w-[100%]">
                    </div>
                    <button type="button"
                            class="bg-green-200 text-black py-2 px-4 mt-5 rounded-lg shadow-md flex flex-row items-center"
                            style="color: rgb(0, 0, 0);">
                        <i class="fas fa-check text-green-600 mr-2" aria-hidden="true"></i>
                        <span class="text-green-600">来访者已确认</span>
                    </button>
                </div>
                <!-- 内容区域 -->
                <div v-else id="agreecontent" class="flex flex-col rounded-xl border border-gray-300 p-4 mt-4">
                    <div class="flex items-center justify-center mb-4">
                        <h4 class="text-lg font-semibold sm:text-xl">录音知情同意书</h4>
                    </div>
                    <div class="mb-4 text-left text-sm sm:text-base">
                        <p class="mb-2">来访者同意心理咨询师对咨询全程进行录音，录音文件用于案例督导分析、学习及讨论。</p>
                        <p>在使用过程中，心理咨询师不得泄露可识别来访者的个人信息包括:姓名、住址、电话、工作单位、体貌特征等。咨询师有责任妥善保管录音文件，在案例结案之后及时删除。若需书面出版引用录音文件相关内容，则需另外征得来访者的同意，并另行签署知情同意书。</p>
                    </div>

                    <!-- 签署信息 (移动端改为垂直布局) -->
                    <div class="flex flex-col gap-4">
                        <!-- 来访者信息 -->
                        <div class="flex border-b pb-3">
                            <div class="flex flex-row items-center">
                                <span class="text-gray-600 min-w-[4em]">来访者：</span>
                                <span id="visitorName" class="ml-2 text-gray-800">待来访者填写</span>
                            </div>
                            <div class="flex flex-row items-center mt-2">
                                <span class="text-gray-600 min-w-[4em]">日期：</span>
                                <span id="visitorDate" class="ml-2 text-gray-800">待填写后生成</span>
                            </div>
                        </div>
                        <!-- 错误提示 (移动端居中显示) -->
                        <el-alert v-if="showConsultantAlert"
                                  type="warning"
                                  description="请输入咨询师名称"
                                  show-icon
                                  class="mt-3"></el-alert>
                        <!-- 咨询师信息 -->
                        <div class="flex flex-col">
                            <div class="flex flex-row items-center">
                                <span class="text-gray-600 min-w-[4em]">咨询师：</span>
                                <input placeholder="请输入姓名"
                                       @blur="checkCNickName"
                                       v-model="consultantNickNmae"
                                       type="text"
                                       class="flex-1 border border-gray-300 rounded-md p-2 ml-2 text-sm" />
                            </div>
                            <div class="flex flex-row items-center mt-2">
                                <span class="text-gray-600 min-w-[4em]">日期：</span>
                                <span class="ml-2 text-gray-800">{{ currentDate }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 操作按钮 (移动端垂直排列) -->
                    <div class="flex flex-col items-center gap-3 mt-4">
                        <button type="button"
                                @click="!showConsultantAlert ? showConfirmEmail = true : showConfirmEmail = false"
                                class="w-full bg-blue-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 text-sm sm:text-base">
                            发送给来访者确认
                        </button>

                        <button type="button"
                                :disabled="confirmObj.confirmSta !== false"
                                @click="showFurtherConfirm=true"
                                class="w-full bg-blue-100 text-blue-400 hover:bg-sky-100 p-2 rounded-lg text-sm sm:text-base">
                            来访者已和我签署了其他同等效力形式的协议，无需二次签署
                        </button>
                    </div>

                </div>


            </div>
        </el-dialog>
        <!--发送邮箱-->
        <el-dialog :visible.sync="showConfirmEmail" width="600px" @close="resetEmail">
            <div class="flex flex-col items-center justify-center p-6 m-6">
                <div class="mb-4">
                    <span class="text-2xl font-semibold">通过邮件发送给来访者确认</span>
                </div>
                <div class="w-full mb-4">
                    <el-input placeholder="请输入邮箱"
                              v-model="visitorEmail" />
                </div>
                <button :disabled="sendEmailEnable" @click="emailSendToV"
                        class="bg-blue-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700">
                    发送
                </button>
            </div>
        </el-dialog>

        <!--确认dialog-->
        <el-dialog :visible.sync="showFurtherConfirm" width="600px">
            <div class=" flex items-center justify-center ">
                <div class="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
                    <div class="flex justify-center mb-6">
                        <div class="bg-yellow-200 rounded-full w-14 h-14 flex items-center justify-center">
                            <i class="fas fa-exclamation-triangle text-warning" style="font-size: 40px;"></i>
                        </div>
                    </div>
                    <div class="text-2xl text-center mb-3 font-semibold">请确认</div>
                    <p class="text-lg text-center mb-6 font-normal">
                        请遵守伦理守则，请确保您的来访者已和您签署同等效力的知情同意书。
                    </p>
                    <div class="flex justify-center gap-4">
                        <button type="button"
                                class="bg-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-400"
                                @click="closeDialog">
                            取消
                        </button>
                        <button type="submit"
                                class="bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
                                @click="confirmAction">
                            确认已签署
                        </button>
                    </div>
                </div>
            </div>
        </el-dialog>

        <ListenDialog v-model="isShowUploadFile" :vobj="VisitorObj"></ListenDialog>
        <div v-if="isSmallScreen">
            <CommonHeader></CommonHeader>
            <div class="mobile-container pt-[80px]">
                <!-- V信息 -->
                <div class="pb-0">
                    <div class="flex flex-row items-center justify-between py-0 mb-6 ">
                        <div class="flex flex-row items-center justify-start ">
                            <div class="w-12 h-12 flex items-center justify-center text-primary bg-gray-200 rounded-full">
                                <span class="text-xl font-medium">{{VisitorObj && VisitorObj.visitorName ? VisitorObj.visitorName.charAt(0):'--'}}</span>
                            </div>
                            <div class="text-2xl pl-6 font-medium">{{VisitorObj && VisitorObj.visitorName ? VisitorObj.visitorName:'--'}}</div>
                        </div>
                        <button @click="openEditor" class="flex items-center justify-center p-2 text-secondary">
                            <i class="fa fa-edit text-gray-600" style="font-size:18px"></i>
                        </button>
                    </div>
                    <div class="mt-2 p-3 flex flex-col gap-2 text-gray-600  text-left text-base">
                        <div>
                            <span class="text-gray-400">年龄: <span class="text-gray-800">{{VisitorObj && VisitorObj.age ?VisitorObj.age:'-'}}岁</span></span>
                        </div>
                        <div>
                            <span class="text-gray-400">性别: <span class="text-gray-800">{{VisitorObj && VisitorObj.gender ? VisitorObj.gender :'-'}}</span></span>
                        </div>
                        <div>
                            <span class="text-gray-400">首次咨询时间: <span class="text-gray-800">{{formattedFirstVisitTime(VisitorObj)}}</span></span>
                        </div>
                        <div>
                            <span class="text-gray-400">联系方式: <span class="text-gray-800">{{VisitorObj && VisitorObj.contact && VisitorObj.contact.length > 0 ? VisitorObj.contact:'未填写'}}</span></span>
                        </div>
                        <div>
                            <span class="text-gray-400">主要症状: <span class="text-gray-800">{{VisitorObj && VisitorObj.symptoms && VisitorObj.symptoms.length > 0 ? VisitorObj.symptoms:'未填写'}}</span></span>
                        </div>
                        <div>
                            <span class="text-gray-400">来访背景关键信息: </span>
                            <div class="text-gray-800 mt-2 line-clamp-3">{{ VisitorObj && VisitorObj.keyinfo && VisitorObj.keyinfo.length > 0 ? VisitorObj.keyinfo : '未填写' }}</div>
                        </div>
                    </div>
                </div>
                <!-- 顶部功能按钮区 -->
                <div class="top-buttons mt-3">
                    <div v-for="(item, index) in topButtonList"
                         :key="index"
                         class="button-item"
                         @click="handleButtonClick(item)">
                        <i v-if="index==0" class="fa fa-pen-square  text-blue-600 text-4xl" />
                        <i v-else-if="index==1" class="fa fa-file-alt  text-blue-600 text-4xl"></i>
                        <i v-else-if="index==2 && confirmObj && confirmObj.confirmSta" class=" fa fa-microphone text-green-600 text-4xl"></i>
                        <i v-else-if="index==2 " class="fa fa-microphone-slash text-blue-600 text-4xl"></i>
                        <p class="button-text font-bold">{{index==2 && confirmObj && confirmObj.confirmSta? "已同意":item.text }}</p>

                    </div>
                </div>

                <!-- 导航栏 -->
                <div class="tab-bar">
                    <div v-for="(tab, tabIndex) in tabs"
                         :key="tabIndex"
                         :class="['tab-item','text-lg font-blod', { active: dyncSelect === tab.value }] "
                         @click="setPage(tab.value)">
                        {{ tab.label }}
                    </div>
                </div>




                <!-- 内容列表区 -->
                <div class="content-list " v-if="activityList.length>0">
                    <div v-for="(item, listIndex) in  activityList"
                         :key="listIndex"
                         class="content-item" @click="activityClick(listIndex)">
                        <div class="item-header">
                            <div class="flex items-center justify-center rounded-full p-2 bg-purple-600 text-white shadow-lg">
                                <i v-if="item.type=='test'" class="fa fa-pen-square" />
                                <i v-else-if="item.type=='train'" class="fa fa-user-friends text-base"></i>
                                <i v-else-if="item.type=='listen'" class="fa fa-file-alt"></i>
                            </div>
                            <!--<span class="tag" :style="{ backgroundColor: item.tagBg }">{{ item.tipinfo }}</span>-->
                            <span class="item-title">{{ item.activityTitle }}</span>
                        </div>
                        <div class="flex flex-row justify-between">
                            <p class="item-subtitle">{{ item.visitorName }}</p>
                            <p :class="getMapColor(item.state)" class="rounded px-2 text-sm p-1 whitespace-nowrap ">{{ item.state }}</p>
                        </div>
                        <p class="item-desc">{{ item.abstract }}</p>
                        <p class="item-time">{{ item.createTime }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <header class=" fixed sticky top-0 left-0 right-0 h-[60px] header_style z-10 text-white flex items-center justify-between p-4 ">
                <div class="flex items-center">
                    <img src="@/assets/logo.png" alt="Logo" class="h-8 mr-2" />
                    <!--<span class="text-xl">识心智能</span>-->
                </div>
                <RecordModule v-model="isRecordVisible" />
                <LoginModule @loginSucc="handleLogin" ref="loginModule" />
            </header>
            <div class="flex w-full h-[calc(100vh-60px)] ">
                <!-- V信息 -->
                <div class="h-full w-1/3  bg-transparent p-4">
                    <div class="h-full overflow-auto px-3 relative border-r border-gray-300 border-1">
                        <div class="pb-0">
                            <div class="flex items-center justify-between py-0 mb-6">
                                <div class="flex items-center justify-start ">
                                    <div class="w-12 h-12 flex items-center justify-center text-primary bg-gray-200 rounded-full">
                                        <span class="text-xl font-medium">{{VisitorObj && VisitorObj.visitorName ? VisitorObj.visitorName.charAt(0):'--'}}</span>
                                    </div>
                                    <div class="text-2xl pl-6 font-medium">{{VisitorObj && VisitorObj.visitorName ? VisitorObj.visitorName:'--'}}</div>
                                </div>
                                <button @click="openEditor" class="flex items-center justify-center p-2 text-secondary">
                                    <i class="fa fa-edit text-gray-600" style="font-size:18px"></i>
                                </button>
                            </div>
                            <div class="mt-2 flex flex-col gap-2 text-gray-600  text-left text-base">
                                <div>
                                    <span class="text-gray-400">年龄: <span class="text-gray-800">{{VisitorObj && VisitorObj.age ?VisitorObj.age:'-'}}岁</span></span>
                                </div>
                                <div>
                                    <span class="text-gray-400">性别: <span class="text-gray-800">{{VisitorObj && VisitorObj.gender ? VisitorObj.gender :'-'}}</span></span>
                                </div>
                                <div>
                                    <span class="text-gray-400">首次咨询时间: <span class="text-gray-800">{{formattedFirstVisitTime(VisitorObj)}}</span></span>
                                </div>
                                <div>
                                    <span class="text-gray-400">联系方式: <span class="text-gray-800">{{VisitorObj && VisitorObj.contact && VisitorObj.contact.length > 0 ? VisitorObj.contact:'未填写'}}</span></span>
                                </div>
                                <div>
                                    <span class="text-gray-400">主要症状: <span class="text-gray-800">{{VisitorObj && VisitorObj.symptoms && VisitorObj.symptoms.length > 0 ? VisitorObj.symptoms:'未填写'}}</span></span>
                                </div>
                                <div>
                                    <span class="text-gray-400">来访背景关键信息: </span>
                                    <div class="text-gray-800 mt-2 line-clamp-3">{{ VisitorObj && VisitorObj.keyinfo && VisitorObj.keyinfo.length > 0 ? VisitorObj.keyinfo : '未填写' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="pr-4">
                            <!--ai 共听 -->
                            <div class="flex flex-col gap-4  ">
                                <div class="pt-2">
                                    <div class="flex flex-col">
                                        <div class="">
                                            <div class="outai relative border-b-2 border-blue-300 hover:border-b-4 hover:bg-gray-100 transition duration-200 ease-out
 rounded-xl bg-sky-200">
                                                <div class="flex gap-4 p-4">
                                                    <div class="flex items-center justify-center rounded-full w-10 h-10 bg-purple-600 text-white shadow-lg">
                                                        <i class="fa fa-pen-square" />
                                                    </div>
                                                    <div class="flex justify-between text-left">
                                                        <div>
                                                            <h3 class="text-lg font-semibold mb-1">智能化咨询记录</h3>
                                                            <div class="text-gray-600">上传对话录音文件或在线录音</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="  innerai">
                                                    <div class="flex flex-col gap-3 p-4">
                                                        <button class="flex w-full bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200" @click="toggleUpLoad">
                                                            <i class="far fa-file-alt text-2xl  p-4"></i>
                                                            <div>
                                                                <h5 class="font-bold  text-base text-left">上传录音/对话稿文件</h5>
                                                                <div class="text-gray-500  text-sm">上传来访对话录音或文本文件</div>
                                                            </div>
                                                        </button>
                                                        <!--<button class="flex items-center  w-full bg-gray-200 text-gray-500 rounded-lg cursor-not-allowed" disabled>
                                                        <i class="far fa-file-alt text-2xl p-4"></i>
                                                        <div>
                                                            <h5 class="font-bold text-base text-left">在腾讯会议中使用</h5>
                                                            <div class="text-gray-500  text-sm">功能即将上线, 敬请期待!</div>
                                                        </div>
                                                    </button>-->
                                                        <button @click="toogleRecord" class="flex items-center  w-full  bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 rounded-lg ">
                                                            <i class="far fa-file-alt text-2xl p-4"></i>
                                                            <div>
                                                                <h5 class="font-bold text-base text-left">在线录音</h5>
                                                                <div class="text-gray-500  text-sm"></div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- AI 测试 -->
                            <div class="flex flex-col gap-4 " @click="toggleOverlay">
                                <div class="pt-2">
                                    <div class="flex flex-col gap-2  ">
                                        <div class="py-2 ">
                                            <div class="cursor-pointer border-b-2 border-blue-300 hover:border-b-4 hover:bg-sky-300  rounded-xl shadow-lg transition-transform transform hover:-translate-y-1 bg-sky-200">
                                                <div class="flex items-start gap-4 p-3">
                                                    <div class="flex items-center justify-center rounded-full w-10 h-10 bg-green-400 text-white shadow-lg">
                                                        <i class="fa fa-file-alt"></i>
                                                    </div>
                                                    <div class="flex justify-between text-left">
                                                        <div>
                                                            <h3 class="text-lg font-semibold  mb-1">智能化心理测评</h3>
                                                            <div class="text-gray-500 text-sm">来访填写后将生成智能测评报告</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--同意确认-->
                        <div class="py-2  mr-4">
                            <div class="rounded-lg border border-[#1F2F4C29] p-4 flex flex-col gap-6 mt-4">
                                <div class="text-left">
                                    <p class="text-base text-gray-700">录音知情同意书</p>
                                    <p class="text-sm text-gray-500">发送给来访确认同意进行对话录音</p>
                                </div>

                                <div class="rounded-lg border border-[#1F2F4C29] p-4 flex flex-col items-center h-48  w-full">
                                    <i class="fas fa-file-alt text-gray-400" style="font-size: 32px;" aria-hidden="true"></i>
                                    <div class="pt-3 font-semibold text-base text-gray-700">确认状态</div>
                                    <span v-if="confirmObj.confirmSta" class="text-sm text-red-500 text-bold">已确认</span>
                                    <span v-else class="text-sm text-[#A8AAAE]">未确认</span>
                                    <button class="p-2 mt-3 rounded-lg bg-gray-200 text-gray-600" @click="viewConfirm">
                                        查看内容
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 功能按钮  -->
                <div class="flex flex-col h-[calc(100vh-70px)]  w-[70%] ">
                    <div class="px-4 mb-4 mt-6 w-full">
                        <div class="px-4 mb-4 ">
                            <div class="flex space-x-2 " role="tablist">
                                <button v-for="item in tabs"
                                        :key="item.value"
                                        type="button"
                                        class="hover:text-indigo-600 hover:bg-cyan-200 rounded-lg p-1 px-7 text-sm p-2"
                                        :class="{'bg-blue-700 text-white': dyncSelect === item.value, ' text-black': dyncSelect !== item.value}"
                                        role="tab"
                                        :aria-selected="dyncSelect === item.value"
                                        :value="item.value"
                                        @click="setPage(item.value)">
                                    <span class="flex items-center">
                                        <div class="text-truncate font-medium">{{ item.label }}</div>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="flex w-full h-[calc(100vh-170px)]  ">
                        <div class="flex flex-col w-full mt-4">
                            <div v-if="activityList.length==0" class="empty-container flex flex-col items-center">
                                <div class="empty-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="119" height="117" fill="none">
                                        <path fill="#EAEEF9" d="M116.294 58.147c0 11.651-3.446 22.537-9.408 31.617-1.313 2.079-2.735 3.939-4.267 5.798-10.667 12.636-26.64 20.677-44.417 20.677s-33.75-8.095-44.417-20.677c-1.532-1.86-2.954-3.72-4.267-5.743-1.532-2.407-3.009-4.978-4.212-7.658-.93-2.134-1.86-4.322-2.516-6.62A53 53 0 0 1 .438 65.04c-.164-.875-.22-1.75-.274-2.735C.11 60.937 0 59.46 0 58.038c0-16.246 6.619-30.852 17.34-41.409 1.094-1.094 2.298-2.133 3.446-3.173C30.961 5.142 43.98 0 58.202 0a58.1 58.1 0 0 1 31.07 8.97c.438.22.82.493 1.258.821.383.274.82.493 1.149.821 2.188 1.532 4.321 3.227 6.236 5.087 1.148 1.094 2.297 2.188 3.282 3.392 1.258 1.422 2.516 2.844 3.61 4.43.273.383.492.712.82 1.094.274.383.493.712.821 1.094 3.282 4.869 5.798 10.23 7.549 15.918.273 1.04.601 1.97.82 3.009a63.5 63.5 0 0 1 1.477 13.511"></path>
                                        <path fill="#D5DDEA" d="M111.426 89.764v5.799H13.73c-1.532-1.86-2.954-3.72-4.267-5.744h101.963zM114.106 45.128h-47.37V42.12h46.55c.382.93.601 1.969.82 3.008"></path>
                                        <path fill="#fff" d="M105.025 25.053v17.45H80.848V10.337h8.97c.383.274.821.493 1.15.82 2.187 1.533 4.32 3.228 6.235 5.088 1.149 1.094 2.298 2.188 3.282 3.392 1.258 1.422 2.517 2.844 3.611 4.43.382.274.711.657.929.985"></path>
                                        <path fill="#D5DDEA" d="M105.026 25.053c-.274-.383-.493-.711-.821-1.094v17.778H81.668V11.104h9.3c-.383-.273-.712-.492-1.15-.82-.382-.274-.82-.493-1.257-.82h-8.588v33.75h25.709V26.147a8 8 0 0 0-.656-1.094"></path>
                                        <path fill="#EAEEF9" d="M100.595 19.583V36.65H85.224V16.192h11.98a33 33 0 0 1 3.391 3.391"></path>
                                        <path fill="#CAD3E2" d="M39.275 88.78c0 .492-.383.875-.82 1.039H9.463c-1.531-2.407-3.008-4.978-4.212-7.658a18.8 18.8 0 0 0 2.407-6.619c.164-.711.219-1.368.274-2.079h21.716c.055.657.219 1.313.383 2.079.82 3.939 2.954 8.862 7.439 12.198h.711c.657 0 1.094.493 1.094 1.04"></path>
                                        <path fill="#DEE5EF" d="M59.679 16.027V73.08a2.393 2.393 0 0 1-2.407 2.407H2.79Q1.149 70.564.492 65.15c-.164-.876-.219-1.75-.273-2.735-.055-1.422-.164-2.845-.164-4.267 0-16.246 6.619-30.851 17.34-41.409 1.094-1.094 2.297-2.133 3.446-3.172h36.321a2.5 2.5 0 0 1 2.517 2.461"></path>
                                        <path fill="#D5DDEA" d="M59.679 16.027V65.15H.492c-.164-.876-.219-1.75-.273-2.735-.055-1.422-.164-2.845-.164-4.267 0-16.246 6.619-30.851 17.34-41.409 1.094-1.094 2.297-2.133 3.446-3.172h36.321a2.5 2.5 0 0 1 2.517 2.461"></path>
                                        <path fill="#fff" d="M56.506 16.739v45.73H.273C.22 61.046.11 59.624.11 58.202c0-16.246 6.62-30.851 17.34-41.409h39.057zM18.544 72.588c1.093 0 1.969-.875 1.969-1.97 0-1.093-.876-1.968-1.97-1.968s-1.969.875-1.969 1.969.875 1.969 1.97 1.969"></path>
                                        <path fill="#989FB0" d="M29.374 76.417v2.352h-1.64c-.93 0-1.751.82-1.751 1.75v3.283c0 .93.82 1.75 1.75 1.75h1.641v2.517c0 .875.712 1.64 1.641 1.64h7.276c.875 0 1.64-.71 1.64-1.64V76.308H29.375zm-1.64 7.932a.47.47 0 0 1-.438-.438V80.63a.47.47 0 0 1 .437-.437h1.641v4.212h-1.64z"></path>
                                        <path fill="#fff" d="M34.735 62.578c.656 1.64.82 3.282-.164 4.54-.93 1.313-1.641 3.063-.657 4.43.93 1.313 1.259 2.353.876 3.01-.383.655 0-.056 1.258-1.478 1.094-1.148-.875-2.133-.93-3.063-.055-.875 1.04-2.735 1.04-3.938-.056-1.313-.657-3.01-1.423-3.501M32 69.744c.273.82.383 1.64-.055 2.297-.437.656-.82 1.532-.273 2.188.492.656.601 1.149.437 1.532s0 0 .657-.712c.492-.601-.438-1.094-.492-1.531-.055-.438.492-1.313.492-1.97-.055-.71-.328-1.531-.766-1.805"></path>
                                        <path fill="#989FB0" d="M61.265 77.949c.602-1.313 2.626-3.83 4.704-4.869.274-.164.602-.054.711.22.602 1.038 2.079 3.664 1.532 6.235-.711 3.118-6.947-1.586-6.947-1.586M58.694 78.168s-2.626-2.845-4.321-3.884a.836.836 0 0 0-1.15.383c-1.859 3.5-1.859 7.548-1.421 9.682.492 2.297 4.43-4.048 4.43-4.048z"></path>
                                        <path fill="#D5DDEA" d="M57.49 79.098s-1.64-1.75-2.625-2.407c-.274-.11-.602-.055-.711.219-1.094 2.188-1.149 4.65-.82 5.962.327 1.422 2.734-2.516 2.734-2.516zM62.96 78.113c.329-.876 1.642-2.517 2.9-3.173q.246-.082.492.164c.328.656 1.258 2.352.93 4.048-.437 2.079-4.321-1.04-4.321-1.04"></path>
                                        <path fill="#fff" d="M114.27 111.973c-5.579-2.352-4.759-9.682-4.212-16.465h1.423v-5.799c0-.054-2.571.055-2.845.055-1.258 0-1.914-.711-2.954-1.149.11.055-.273 3.009-.328 3.337-1.805 7.932-5.47 10.722-2.024 14.386 1.039 1.095 1.532 3.447-.875 4.486-2.407.93-3.83-2.571-4.65-4.267-1.422-2.954-.219-7.33 1.313-16.3 0 0-17.012-.055-21.88 0-.328 1.367-3.064 10.885-3.446 12.854-.602 2.954.382 5.087.601 6.674.22 1.695-2.625 2.844-4.759.93-2.735-2.517.165-6.4.547-15.043 0-.492.165-5.798-.164-5.798-5.634 0-11.213-.055-16.848.054-.656 0-1.64.274-2.023-.328-3.064-4.485 4.704-14.605 13.347-11.98 1.422.438 2.953 1.368 4.485 1.477 0 0 .875-.273 5.306-3.5 7.44-4.267 16.793-3.939 22.591-2.571 7.823 1.86 9.19 8.15 11.433 10.94 3.227 4.048 6.29 5.087 5.853 14.988-.164 3.993-.219 6.126 3.063 8.424 2.188 1.75.438 6.017-2.954 4.595"></path>
                                        <path fill="#AAB2C5" d="M63.508 80.52h-.055l-1.532-.219c-.273 0-.437-.273-.437-.492 0-.274.273-.438.492-.438l1.532.219c.273 0 .437.273.437.492 0 .329-.218.438-.437.438M56.123 80.684h.055l1.531-.219c.274 0 .438-.274.438-.492 0-.274-.274-.438-.492-.438l-1.532.219c-.274 0-.438.273-.438.492.11.219.22.383.438.438"></path>
                                        <path fill="#989FB0" d="m67.974 41.954-.46-2.64 10.329-1.8.46 2.64-5.578 9.722 7.173-1.25.46 2.64-10.788 1.88-.46-2.64 5.578-9.722zM64.02 60.163l.479-1.57 6.068 1.855-.48 1.57-5.598 3.722 4.185 1.28-.48 1.569-6.382-1.95.48-1.57 5.599-3.723z"></path>
                                        <path fill="#D5DDEA" d="M106.174 89.874h5.252v-.055 5.798h-6.455"></path>
                                    </svg>
                                </div>
                                <div class="empty-text">暂无数据</div>
                            </div>
                            <div v-else class="overflow-y-auto scrollable pb-8  w-full">
                                <div v-for="(activity,index) in activityList" :key="index" class="px-4 w-full" @scroll="handleScroll" ref="act_container">
                                    <div class="bg-white shadow rounded-lg mb-5 hover:bg-gray-200 w-full" @click="activityClick(index)">
                                        <div class="p-5">
                                            <div class="flex justify-between items-center">
                                                <div class="flex items-center">
                                                    <div class="bg-[#FBF0F2] rounded">
                                                        <img src="@/assets/sim.png" class="h-8 w-8" alt="Icon">
                                                    </div>
                                                    <h4 class="px-4 font-bold text-gray-600">{{activity.tipinfo}}</h4>
                                                </div>
                                                <span :class="getMapColor(activity.state)" class="rounded px-2 text-sm p-1">{{activity.state}}</span>
                                            </div>
                                        </div>
                                        <div class="px-6 text-left" style="color: rgba(47, 43, 61, 0.55) ">{{activity.activityTitle}}</div>
                                        <div class="ml-3 mr-3 mt-2 px-5 py-2 text-gray-300 text-left rounded-lg text-sm" style="background-color: #f3f3f4  ;color:rgba(47, 43, 61, 0.7) ">
                                            {{activity.abstract}}
                                        </div>
                                        <div class="flex  items-center px-6  pb-4 pt-2">
                                            <div class="flex items-center">
                                                <div class="bg-blue-100 text-yellow-800 rounded-full w-8 h-8 flex items-center justify-center">
                                                    <span>{{activity.visitorName.charAt(0)}}</span>
                                                </div>
                                                <div class="text-xs text-gray-600 px-2">{{activity.visitorName}}</div>
                                            </div>
                                            <div class="text-xs px-4 text-gray-400">{{activity.createTime}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="freshState === 'error'" class="error-message pb-8">
                                    加载失败，点击<a @click.prevent="retryLoading" class="text-blue-500 cursor-pointer ">重试</a>
                                </div>
                                <div v-else-if="freshState === 'loading'" class="loading-indicator pb-8">
                                    加载中...
                                </div>
                                <div v-else-if="freshState === 'complete'" class="no-more-data pb-8">
                                    没有更多数据了
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LoginModule from './LoginModule.vue';
    import { mapState, mapActions } from 'vuex';
    import axios from 'axios';
    import { ref } from 'vue';
    /*
    import { jwtDecode } from 'jwt-decode';
    */
    import RecordModule from './RecordModule.vue'; 
    import ListenDialog from './subassembly/ListenDialog.vue';
    import QuestionDialog from './subassembly/QuestionDialog.vue'; 
    import CommonHeader from './subassembly/CommonHeader.vue';
    export default {
        components: {
            LoginModule,
            RecordModule,
            ListenDialog,
            QuestionDialog,
            CommonHeader,
        },
        name: 'VisitorPage',
        metaInfo: {
            title: '识心智能 - AI助手',
            meta: [
                {
                    name: 'description',
                    content: '识心智能官网，各行各业量身定制专属的智能心理健康解决方案，以AI科技的力量促进心理健康事业的创新与繁荣发展'
                },
                {
                    name: 'keywords',
                    content: '识心智能, 心理健康, 心理健康AI, 心理AI, 健康AI, 心理健康方案, 声音疗愈, 智慧校园, 校园心理, 咨询师AI助手'
                }
            ]
        },
        setup() {
            const formRef = ref(null);
            const rules = {
                visitorName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
                age: [
                    { required: true, message: '请输入年龄', trigger: 'blur' },
                    { pattern: /^[1-9][0-9]*$/, message: '年龄必须是正整数', trigger: 'blur' }
                ],
                visitDate: [{ required: true, message: '请选择首次访问时间', trigger: 'change' }]
            };

            const submitAddVisitorFormCheck = async () => {
                try {
                    const valid = await new Promise((resolve) => {
                        formRef.value.validate((valid) => {
                            resolve(valid);
                        });
                    });
                    if (valid) {
                        console.log('表单验证通过');
                        // 这里可以添加提交表单的逻辑
                    } else {
                        console.log('表单验证失败');
                    }
                } catch (error) {
                    console.error('表单验证出错:', error);
                }
            };

            return {
                rules,
                formRef,
                submitAddVisitorFormCheck,
            };
        },
        data() {
            return {
                freshState: 'idle', // 'idle'|'loading'|'error'|'complete'
                activityList: [
                    {
                        type: "test",
                        tipinfo: "TIP: 其他功能示例都是以该模拟来访咨询内容作为背景",
                        activityTitle: "【测评报告】/咨询报告·xxx",
                        state: "已完成",
                        visitorName: "官方示例",
                        createTime: "09-16 00:00",
                        abstract: "咨询师表现出很强的共情能力和理解力，通过多次使用“拥抱”等情感回应，成功建立了一个支持性的谈话环境。咨询师倾听对方的烦恼，尤其是在谈到家庭背景和个人压力来源时展现了深刻的理解。例如，询问对方关于与母亲的关系时，能够深入探讨对方的情感体验，为建立信任打下基础。",
                    }
                ],
                topButtonList: [
                    { icon: 'https://unsplash.com/photos/N7XodRrbzS0', text: '智能化咨询记录' },
                    { icon: 'https://picsum.photos/60/60?random=2', text: '智能化心理测评' },
                    { icon: 'https://picsum.photos/60/60?random=2', text: '录音权限未确认' },
                  
                ],
                fileList: [],
                showEditInfo: false,
                sendEmailEnable: false,
                isRecordVisible:false,
                isOverlayVisible:false,
                isShowUploadFile:false,
                confirmObj: {
                    confirmSta: false,
                    visitorSign: "",//base64 pic	
                    signTime: null,
                    sendDate: null,
                    signType:null, 
                },
                // activity
                listenObj: {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                },
                testObj: {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                },
                consultantNickNmae:null,
                currentDate: this.getCurrentDate(),
                visitorEmail:null,
                dyncSelect: 'all',
                showConfirmEmail: false,
                showConsultantAlert: false,
                tabs: [
                    { value: 'all', label: '全部' },
                    { value: 'conclusion', label: '咨询报告' },
                    { value: 'evaluation', label: '测评报告' },
                ],
                activityCurPage: 0,
                showFurtherConfirm:false,
                isShowSoundRecording: false,
                shows_1: false,
                VisitorObj: null,
                form_addvisitor :{
                    visitorName: '匿名',
                    gender: '',
                    age: '',
                    visitDate: '',
                    contact: '',
                    backgroundInfo: '',
                    symptoms: '',
                    useLanguage: '普通话',
                }
            };
        },
        created() {
            this.initDyncParams();
            this.getVisitorObj();
            setTimeout(() => {
                this.getVisitorAgreeInfo();
                this.activityList.splice(0, this.activityList.length);
                this.getAllTypeInfo();
            }, 1000);
            
        },
        computed: {
            ...mapState({
                globalCharacters: state => state.globalCharacters,
                globalScales: state => state.globalScales,
            }),
            displayContent() {
                const maxLength = 300; // 先截断超长内容
                if (!this.activity || !this.activity.abstract) {
                    return "";
                }
                if (this.activity.abstract.length <= maxLength) {
                    return this.activity.abstract;
                }
                return this.activity.abstract.substring(0, maxLength) + '...';
            },
           
        },
        methods: {
            ...mapActions(['fetchGlobalCharacters', "fetchGlobalScales"]),
            listenUpdateSuccess() {
                this.freshState = 'idle';
                this.initDyncParams();
                this.activityList.splice(0, this.activityList.length);
                this.getAllTypeInfo();
            },
            handleButtonClick(item) {
                console.log(item);
                if (item.text.startsWith("录音")) {
                    this.viewConfirm();
                } else if (item.text.startsWith("智能化心理测评")) {
                    this.toggleOverlay();
                } else if (item.text.startsWith("智能化咨询记录")) {
                    this.toggleUpLoad();
                }
            },
            initDyncParams() {
                this.listenObj = {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                };
                this.testObj = {
                    HasMore: false,
                    Curpage: 0,
                    ActivityList: [],
                    pageItemNum: 0,
                };
            },
            async getVisitorObj() {
                try {
                    const token = localStorage.getItem('token');
                    if (!token) return {};

                    // 优先从路由参数获取
                    if (this.$route.params?.visitorInfo) {
                        try {
                            const jsonString = decodeURIComponent(this.$route.params.visitorInfo);
                            if (jsonString && !['null', 'undefined'].includes(jsonString)) {
                                const parsed = JSON.parse(jsonString);
                                if (parsed?.visitorid) {
                                    localStorage.setItem("pv", parsed.visitorid);
                                    this.VisitorObj = parsed;
                                    return ;
                                }
                            }
                        } catch (e) {
                            //console.error("路由参数解析失败:", e);
                        }
                    }

                    const vid = localStorage.getItem("pv");
                    this.VisitorObj = vid ? await this.getVinfo(vid) : {};
                    console.log(this.VisitorObj);
                } catch (error) {
                    console.error("VisitorObj出错:", error);
                    return;
                }
            },
            async getVinfo(pv) {
                try {
                    const token = localStorage.getItem('token');
                    if (!token) return {};

                    const response = await axios.get(`/api/visitor/getinfo/${pv}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });

                    if (response.status === 200 && response.data.code === "00") {
                        return response.data.vinfo || {};
                    }
                } catch (error) {
                    //console.error('获取访客信息失败:', error);
                }
                return {};
            },
            getMapColor(staStr) {
                switch (staStr) {
                    case "进行中":
                        return 'bg-green-100 text-green-600';
                    case "处理中":
                        return 'bg-yellow-100 text-yellow-600';
                    case "阶段完成":
                        return 'bg-blue-100 text-blue-600';
                    case "转换中":
                        return 'bg-purple-100 text-purple-600';
                    case "已完成":
                        return 'bg-teal-100 text-teal-600';
                    case "异常":
                        return 'bg-red-100 text-red-600';
                    default:
                        return 'bg-gray-100 text-gray-800';
                }
            },
            addVisitorClose() {
                this.form_addvisitor = {
                    visitorName: '匿名',
                    gender: '',
                    age: '',
                    visitDate: '',
                    contact: '',
                    symptoms: '',
                    backgroundInfo: '',
                    useLanguage: '普通话',
                };
            },
            toogleRecord() {
                this.isRecordVisible = !this.isRecordVisible;
            },
            formattedFirstVisitTime(visitorObj) {
                if (!visitorObj) { return ""; }
                const date = new Date(visitorObj.firstVisitTime);
                return date.toLocaleString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                }).replace(/\//g, '-'); // 将 / 替换为 -
            },
            checkCNickName() {
                if (!this.consultantNickNmae) {
                    this.showConsultantAlert = true;
                } else {
                    this.showConsultantAlert = false;
                }
            },
            validateEmail() {
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!this.visitorEmail) {                    
                    this.$message.error('邮箱不能为空');
                    return false;
                } else if (!emailPattern.test(this.visitorEmail)) {
                    this.$message.error('邮箱格式不正确');
                    return false;
                }
                return true;
            },
            getCurrentDate() {
                const date = new Date();
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
                const day = String(date.getDate()).padStart(2, '0'); // 确保两位数
                return `${year}/${month}/${day}`; // 格式：YYYY/MM/DD
            },
            resetEmail() { this.visitorEmail = null },
            checkVid() {
                if (this.VisitorObj && this.VisitorObj.visitorid) {
                    return 0;
                }
                return 1;
            },
            async emailSendToV() {
                if (this.checkVid()) { return; }
                if (!this.validateEmail()) {
                    return;
                }
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.$refs.loginModule.showLogin();
                    }, 2000);
                    return;
                }

                this.sendEmailEnable = true;
                try {
                    const payload = {
                        email: this.visitorEmail,                        
                        sendDate: this.currentDate,                        
                        cname: this.consultantNickNmae,
                        cid: this.$route.params.cid,
                        vid: this.VisitorObj.visitorid,//null
                    };
                    console.log(payload);
                    const response = await axios.post('/api/sendconfirm', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });

                    if (response.data.code == "00") {
                        this.showConfirmEmail = false;
                        this.showFurtherConfirm = false;
                        this.isShowSoundRecording = false;
                    }
                } catch (error) {
                    console.error('send failed:', error);
                    this.$message({
                        message: "发送失败，请稍后重试",
                        type: "error"
                    });
                }
                setTimeout(() => {
                    this.sendEmailEnable = false;
                }, 10000);
            },
            closeDialog() {
                this.showFurtherConfirm = false;
                this.showEditInfo = false;
            },
            viewConfirm() {
                if (this.checkVid()) { return; }

                this.isShowSoundRecording = true;
            },
            soundRecordClose() {
                this.isShowSoundRecording = false;
            },
            setPage(selectedPage) {
                if (selectedPage == this.dyncSelect) {
                    return;
                }
                this.activityList.splice(0, this.activityList.length);
                for (const item of this.tabs) {
                    if (item.value == selectedPage) {
                        this.dyncSelect = selectedPage;
                        this.getAllTypeInfo();
                        break;
                    }
                }
            },
            toggleUpLoad() {
                this.isShowUploadFile = !this.isShowUploadFile; // 切换覆盖层状态
                if (!this.isShowUploadFile) {
                    this.fileList.splice(0, this.fileList.length);
                    this.selectedEditionIndex = 0;
                    this.editionDetailId = 0;
                }
            },
            toggleOverlay() {
                this.isOverlayVisible = !this.isOverlayVisible; // 切换覆盖层状态
            },
            checkIsChange() {
                this.VisitorObj;
                if (this.form_addvisitor.age != this.VisitorObj.age || this.form_addvisitor.visitorName != this.VisitorObj.visitorName
                    || this.form_addvisitor.gender != this.VisitorObj.gender || this.form_addvisitor.visitDate != this.VisitorObj["firstVisitTime"]
                    || this.form_addvisitor.contact != this.VisitorObj.contact || this.form_addvisitor.backgroundInfo != this.VisitorObj["keyinfo"]
                    || this.form_addvisitor.symptoms != this.VisitorObj.symptoms) {
                    return true;
                }
                return false;
            },
            async submitAddVisitorForm() {
                if (!this.checkIsChange()) {
                    this.$message.info("未做任何修改，退出");
                    this.showEditInfo = false;
                    return;
                }
                console.log(this.formRef);

                const isValid =  this.submitAddVisitorFormCheck();
                if (!isValid) {
                    return;
                }
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.$refs.loginModule.showLogin();
                    }, 2000);
                    return;
                }
                try {
                    const payload = {
                        visitorid: this.VisitorObj.visitorid,
                        name: this.form_addvisitor.visitorName,
                        age: this.form_addvisitor.age,
                        gender: this.form_addvisitor.gender,
                        visitDate: this.form_addvisitor.visitDate,
                        contact: this.form_addvisitor.contact,
                        symptoms: this.form_addvisitor.symptoms,
                        backgroundInfo: this.form_addvisitor.backgroundInfo,
                    };

                    const response = await axios.post('/api/visitor/modify', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    this.VisitorObj.age = this.form_addvisitor.age;
                    this.VisitorObj.gender = this.form_addvisitor.gender;
                    this.VisitorObj.visitorName = this.form_addvisitor.visitorName;
                    this.VisitorObj.contact = this.form_addvisitor.contact;
                    this.VisitorObj.symptoms = this.form_addvisitor.symptoms;
                    this.VisitorObj.keyinfo = this.form_addvisitor.backgroundInfo;
                    this.VisitorObj.firstVisitTime = this.form_addvisitor.visitDate;

                    this.isVisitorVisible = false;
                    this.showEditInfo = false;

                } catch (error) {
                    console.error('add failed:', error);
                    this.registrationMessage = 'add visitor failed. Please try again.';
                }
            },
            async getVisitorAgreeInfo() {
                if (this.checkVid()) { return; }
                const token = localStorage.getItem('token');
                
                if (!token) {
                    return;
                }
                try {
                    const payload = {
                        visitorid: this.VisitorObj.visitorid,
                    };
                    console.log(payload);
                    const response = await axios.post('/api/visitor/agree/info', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.data.code == "00") {
                        var signData = response.data.signData
                        var signTime = response.data.signTime
                        var sendDate = response.data.sendDate
                        var signType = response.data.signType
                        console.log("======sign info=======");
                        console.log(signData);
                        console.log(signTime);
                        console.log(sendDate);
                        console.log(signType);
                        this.confirmObj.confirmSta = true;
                        this.confirmObj.signTime = signTime;
                        this.confirmObj.sendDate = sendDate;
                        this.confirmObj.signType = signType;
                        if (signType =="visitor") {
                            this.confirmObj.visitorSign = signData;
                        }
                    }
                } catch (error) {
                    console.error('get agree info failed:', error);
                }
            },
            async confirmAction() {
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.$refs.loginModule.showLogin();
                    }, 2000);
                    return;
                }
                try {
                    const payload = {
                        submitTime: Date.now(),
                        visitorid: this.VisitorObj.visitorid,
                        selfConfirm: "selfConfirm",
                    };
                    console.log(payload);
                    const response = await axios.post('/api/visitor/agree/other', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });

                    if (response.data.code == "00") {
                        this.showConfirmEmail = false;
                        this.showFurtherConfirm = false;
                        this.isShowSoundRecording = false;
                    }
                } catch (error) {
                    console.error('send failed:', error);
                    this.$message({
                        message: "发送失败，请稍后重试",
                        type: "error"
                    });
                }

            },
            getStatusMapping(staStr) {
                const stalist = ["create", "inProcess", "stageFinish", "modelProcess", "finish", "error", "success"];
                const maplist = {
                    "create": "进行中",
                    "inProcess": "处理中",
                    "stageFinish": "作答完成",
                    "modelProcess": "转换中",
                    "finish": "已完成",
                    "success": "已完成",
                    "error": "异常",
                    "unkonow": "未知"
                }

                if (stalist.includes(staStr)) {
                    return maplist[staStr];
                } else {
                    return maplist["unkonow"];
                }
            },

            mapObj2ActList(itemList) {
                if (itemList.length > 0) {
                    for (var item of itemList) {
                        var visitorName = "·";
                        if (item.vname) {
                            visitorName = visitorName + item.vname;
                        }
                        console.log(item);
                        var obj = {
                            type: "test",
                            tipinfo: "测评报告" + visitorName,
                            activityTitle: item["Name"],
                            state: this.getStatusMapping(item.state),
                            visitorName: item.vname ? item.vname : "无归属",
                            createTime: item.createTime.slice(5, 16),
                            fulltime: item.createTime,
                            abstract: item["Introduction"],
                            taskid: item.id//todo 暂时使用id
                        };
                        this.activityList.push(obj);
                    }
                }
            },
            async fetchScales() {
                await this.fetchGlobalScales();
            },
            mapScaleToList(scales, showList) {
                const scaleMap = {};
                scales.forEach(scale => {
                    scaleMap[scale._id] = {
                        "Name": scale["Name"],
                        "Introduction": scale["Introduction"],
                        "English_name": scale["English_name"]
                    };
                });

                return showList.map(item => {
                    const match = scaleMap[item.questionId];
                    if (match) {
                        return { ...item, ...match, }
                    } else {
                        return { ...item, "Name": "无法对应", "Introduction": "无" }
                    }
                });
            },
            async genQuestionnaireList() {
                const token = localStorage.getItem('token');
                console.log(token);
                if (!token) {
                    return;
                }
                try {
                    await this.fetchScales();
                } catch (error) {
                    this.$message.error("获取数据失败，请稍后重试！");
                    console.log("get scales error");
                    console.log(error);
                    return;
                }
                try {
                    const response = await axios.get("/api/questionnaire/list", {
                        params: {
                            page: this.testObj.Curpage,
                            vid: this.VisitorObj.visitorid
                        },
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    console.log("=====vq/list=====");
                    console.log(response.data.code);

                    if (response.status == 200 && response.data.code == "00") {
                        if (response.data.allCnt == 0) {
                            console.log("allCnt=0");
                            return;
                        }
                        console.log("=====vq/list=====");
                        console.log(response.data);
                        this.testObj.HasMore = response.data.hasMore;
                        this.testObj.Curpage = response.data.curPage;

                        console.log("this.testObj.Curpage");
                        console.log(this.testObj.Curpage);
                        this.testObj.ActivityList = response.data.itemList;
                        this.testObj.pageItemNum = response.data.allCnt;

                    } else {
                        this.$message.error("生成失败，请稍后重试！");
                        this.freshState = 'error';
                    }
                } catch (error) {
                    this.freshState = 'error';
                }
                console.log("---------------");
                console.log(this.globalScales);
                this.testObj.ActivityList = this.mapScaleToList(this.globalScales, this.testObj.ActivityList);
                this.mapObj2ActList(this.testObj.ActivityList);
            },
            handleActivityList(info, infolist) {
                for (let i = 0; i < infolist.length; i++) {
                    console.log("==listen===");
                    console.log(infolist[i].status);
                    var obj = {
                        type: "listen",
                        tipinfo: `咨询记录·${infolist[i].edition}·${infolist[i].file_name}`,
                        activityTitle: infolist[i].file_name,
                        state: this.getStatusMapping(infolist[i].status),
                        visitorName: infolist[i].vname,
                        createTime: infolist[i].created_at.slice(5, 16),
                        fulltime: infolist[i].created_at,
                        //abstract: "咨询师表现出很强的共情能力和理解力",
                        abstract: `${infolist[i].created_at.slice(5, 16)} 咨询记录`,
                        taskid: infolist[i]["taskid"],
                    }
                    this.activityList.push(obj);
                }
                console.log(this.activityList);
            },
            async getListenInfos() {
                try {
                    const token = localStorage.getItem('token');
                    if (!token) {
                        return;
                    }

                    const response = await axios.get(`/api/listen/list?page=${this.listenObj.Curpage}&vid=${this.VisitorObj.visitorid}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    if (response.data.code == "00") {
                        console.log('successful:', response.data);
                        if (response.data.info) {
                            this.listenObj.pageItemNum = response.data.info.count;
                            this.listenObj.HasMore = response.data.info.hasMore;
                        }
                        this.handleActivityList(response.data.info, response.data.infoList)
                    } else {
                        this.$message({
                            message: response.data.message,
                            type: response.data.type,
                        });
                        this.freshState = 'error';
                    }

                } catch (error) {
                    console.error('get visitors error:', error);                    
                    this.freshState = 'error';
                }
            },
            sortAllactivityList() {
                this.activityList = [...this.activityList].sort((a, b) => {
                    return new Date(b.fulltime) - new Date(a.fulltime);
                });
            },
            async getAllTypeInfo() {
                if (this.checkVid()) { return; }
                const token = localStorage.getItem('token');

                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.$refs.loginModule.showLogin();
                    }, 2000);
                    return;
                }
                switch (this.dyncSelect) {
                    case this.tabs[0].value:
                        await this.getListenInfos();
                        await this.genQuestionnaireList();
                        this.sortAllactivityList();
                        break;
                    case this.tabs[1].value:
                        await this.getListenInfos();
                        this.sortAllactivityList();
                        break;
                    case this.tabs[2].value:
                        await this.genQuestionnaireList();
                        this.sortAllactivityList();
                        break;
                }
            },
            async retryLoading() {
                if (this.isLoadingLock) return;
                this.isLoadingLock = true;
                this.freshState = 'loading';
                try {
                    switch (this.dyncSelect) {
                        case this.tabs[0].value://all
                            console.log("-------[0]tsetx-----");
                            console.log(this.testObj.HasMore);
                            console.log(this.testObj.pageItemNum);
                            console.log(this.testObj.Curpage);
                            console.log("-------listen-----");
                            console.log(this.listenObj.HasMore);
                            console.log(this.listenObj.pageItemNum);
                            console.log(this.listenObj.Curpage);
                            console.log("-------train-----");
                            console.log(this.trainList.HasMore);
                            console.log(this.trainList.pageItemNum);
                            console.log(this.trainList.Curpage);

                            if (!this.listenObj.HasMore && !this.testObj.HasMore && !this.trainList.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            if (this.testObj.pageItemNum && this.testObj.HasMore) {
                                this.testObj.Curpage++;
                            }
                            if (this.listenObj.pageItemNum && this.listenObj.HasMore) {
                                this.listenObj.Curpage++;
                            }
                            break;
                        case this.tabs[1].value:
                            console.log("-------[1]-----");
                            console.log(this.listenObj.HasMore);
                            console.log(this.listenObj.pageItemNum);
                            console.log(this.listenObj.Curpage);
                            if (!this.listenObj.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            if (this.listenObj.pageItemNum && this.listenObj.HasMore) {
                                this.listenObj.Curpage++;
                            }
                            break;
                        case this.tabs[2].value:
                            //this.testObj.Curpage++;
                            console.log("-------[2]-----");
                            console.log(this.testObj.HasMore);
                            console.log(this.testObj.pageItemNum);
                            console.log(this.testObj.Curpage);
                            if (!this.testObj.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            if (this.testObj.pageItemNum && this.testObj.HasMore) {
                                this.testObj.Curpage++;
                            }

                            break;
                    }
                    await this.getAllTypeInfo();
                    switch (this.dyncSelect) {
                        case this.tabs[0].value://all
                            console.log("-------[4]-----");
                            console.log(this.trainList.HasMore);
                            console.log(this.listenObj.HasMore);
                            console.log(this.testObj.HasMore);

                            if (!this.listenObj.HasMore && !this.testObj.HasMore && !this.trainList.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            break;
                        case this.tabs[1].value:
                            if (!this.listenObj.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            break;
                        case this.tabs[2].value:
                            if (!this.testObj.HasMore) {
                                this.freshState = 'complete';
                                return;
                            }
                            break;
                    }
                } catch (error) {
                    this.freshState = 'error';
                }
                finally {
                    this.isLoadingLock = false;
                }
            },
            handleScroll() {
                if (this.freshState !== 'idle') return;

                const container = this.$refs.act_container;
                const threshold = 20;

                if (container.scrollTop + container.clientHeight >= container.scrollHeight - threshold) {
                    this.retryLoading();
                }
            },
            handleLogin() {
                console.log('用户登录:xxxx');
            },
            openEditor() {
                if (this.checkVid()) { return; }
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.$refs.loginModule.showLogin();
                    }, 2000);
                    return;
                }

                this.showEditInfo = true;
                this.form_addvisitor = { ...this.VisitorObj };
                this.form_addvisitor["visitDate"] = this.VisitorObj["firstVisitTime"];
                this.form_addvisitor["backgroundInfo"] = this.VisitorObj["keyinfo"];
            },
            activityClick(index) {
                this.activityCurPage = index;
                console.log("clck" + index);
                var cur = this.activityList[this.activityCurPage]
                if (cur.state == "进行中") {
                    this.$message.info({ message: '请稍等，正在生成中...', duration: 3000 });
                } else {
                    if (cur.type == "test") {
                        localStorage.setItem("router", btoa(JSON.stringify({ id: cur.taskid, type: cur.type })));
                        this.$router.push({ name: 'QuestionResult' });
                    } else {
                        localStorage.setItem("router", btoa(JSON.stringify({ id: cur.taskid, type: cur.type })));
                        this.$router.push({ name: 'ConclusionM' });
                    }
                }
            },

        }
    };
</script>

<style>
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;700&display=swap');
    @import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');
    .header_style {
        background: linear-gradient(135deg, #4299e1, #2c5282,#8070ea #4299e1);
    }
</style>
